/* Kamoflaj Field — theme.js (no dependencies) */
(() => {
'use strict';
const K = window.Kamo || {};
const $ = (s, r = document) => r.querySelector(s);
const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
const html = document.documentElement;
const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
const isMobile = () => matchMedia('(max-width: 749px)').matches;
const animOff = () => reduced || html.classList.contains('no-anim') || (isMobile() && html.classList.contains('no-anim-mobile'));
const clamp = (v, a = 0, b = 1) => Math.min(b, Math.max(a, v));
const fine = matchMedia('(hover: hover) and (pointer: fine)').matches;
/* ---------- Money ---------- */
K.formatMoney = (cents, format = K.moneyFormat || '${{amount}}') => {
if (typeof cents === 'string') cents = cents.replace('.', '');
const fmt = (n, d = 2, t = ',', dec = '.') => {
n = (n / 100).toFixed(d);
const [i, f] = n.split('.');
return i.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + t) + (f ? dec + f : '');
};
return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => ({
amount: fmt(cents), amount_no_decimals: fmt(cents, 0),
amount_with_comma_separator: fmt(cents, 2, '.', ','), amount_no_decimals_with_comma_separator: fmt(cents, 0, '.', ',')
}[k] || fmt(cents)));
};
/* ---------- Toast ---------- */
let toastT;
K.toast = (msg, err = false) => {
const t = $('#Toast'); if (!t) return;
t.textContent = msg; t.classList.toggle('is-error', err); t.classList.add('is-visible');
clearTimeout(toastT); toastT = setTimeout(() => t.classList.remove('is-visible'), 2600);
};
/* ---------- Preloader ---------- */
function preloader() {
const el = $('#Preloader'); if (!el) return Promise.resolve();
const key = 'kamo-preloaded';
if (K.preloader.frequency === 'session' && sessionStorage.getItem(key)) { el.classList.add('is-skip'); return Promise.resolve(); }
return new Promise(res => {
const count = $('[data-count]', el); let p = 0; let loaded = document.readyState === 'complete';
window.addEventListener('load', () => loaded = true, { once: true });
const start = performance.now();
const tick = (now) => {
const target = loaded ? 100 : Math.min(90, (now - start) / 18);
p += (target - p) * 0.12; if (loaded && p > 99.4) p = 100;
count.textContent = String(Math.round(p)).padStart(2, '0');
el.style.setProperty('--p', p / 100);
if (p < 100 && now - start < 6000) return requestAnimationFrame(tick);
try { sessionStorage.setItem(key, '1'); } catch (e) {}
el.classList.add('is-done'); setTimeout(() => { el.remove(); }, 1200); res();
};
requestAnimationFrame(tick);
});
}
/* ---------- Text splitting ---------- */
function splitChars(el) {
if (el.dataset.splitDone) return;
const text = el.textContent.trim();
el.setAttribute('aria-label', text);
el.innerHTML = '';
let i = 0;
text.split(/(\s+)/).forEach(word => {
if (/^\s+$/.test(word)) { el.appendChild(document.createTextNode(' ')); return; }
const w = document.createElement('span'); w.className = 'char-wrap'; w.setAttribute('aria-hidden', 'true');
[...word].forEach(ch => { const c = document.createElement('span'); c.className = 'char'; c.textContent = ch; c.style.setProperty('--ci', i++); w.appendChild(c); });
el.appendChild(w);
});
el.dataset.splitDone = '1';
}
function splitLines(el) {
if (el.dataset.splitDone) return;
const text = el.textContent.trim(); if (!text) return;
const words = text.split(/\s+/);
el.dataset.orig = el.innerHTML;
el.setAttribute('aria-label', text);
el.innerHTML = words.map(w => `<span class="sw" aria-hidden="true">${w.replace(/</g, '&lt;')}</span>`).join(' ');
const spans = $$('.sw', el); const lines = []; let top = null;
spans.forEach(s => { const t = s.offsetTop; if (top === null || Math.abs(t - top) > 4) { lines.push([]); top = t; } lines[lines.length - 1].push(s.textContent); });
el.innerHTML = lines.map((l, i) => `<span class="split-line" aria-hidden="true" style="--li:${i}"><span>${l.join(' ')}</span></span>`).join('');
el.dataset.splitDone = '1';
}
/* ---------- Reveal ---------- */
let io;
function reveals(root = document) {
const els = $$('[data-reveal]', root);
if (animOff() || !('IntersectionObserver' in window)) { els.forEach(e => e.classList.add('is-in')); return; }
els.forEach(el => {
if (el.dataset.reveal === 'lines') { const h = el.matches('h1,h2,h3,h4,p') ? el : $('h1,h2,h3', el); if (h) splitLines(h); }
if (el.dataset.reveal === 'chars') splitChars(el);
});
io = io || new IntersectionObserver(entries => entries.forEach(en => { if (en.isIntersecting) { const t = en.target; t.classList.add('is-in'); io.unobserve(t); const h = t.dataset.orig !== undefined ? t : $('[data-orig]', t); if (h) setTimeout(() => { h.innerHTML = h.dataset.orig; h.removeAttribute('aria-label'); delete h.dataset.orig; delete h.dataset.splitDone; }, 2600); } }), { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
els.forEach(el => io.observe(el));
}
/* ---------- Header ---------- */
function header() {
const h = $('[data-header]'); if (!h) return;
const mode = h.dataset.sticky; let last = scrollY;
const transparent = h.classList.contains('header--transparent');
const onScroll = () => {
const y = scrollY;
if (transparent) { h.classList.toggle('is-solid', y > 40); const a = $('.section-announce'); h.closest('.section-header').style.top = Math.max(0, (a ? a.offsetHeight : 0) - y) + 'px'; }
else h.classList.toggle('is-solid', y > 10);
if (mode === 'scroll-up') h.classList.toggle('is-hidden', y > last && y > 240 && !h.matches(':hover'));
if (mode === 'none') h.closest('.section-header').style.position = transparent ? '' : 'relative';
last = y;
};
addEventListener('scroll', onScroll, { passive: true }); onScroll();
const triggers = $$('[data-mega-trigger]', h), megas = $$('[data-mega]', h);
let closeT;
const close = () => { megas.forEach(m => { m.classList.remove('is-open'); setTimeout(() => { if (!m.classList.contains('is-open')) m.hidden = true; }, 400); }); triggers.forEach(t => t.setAttribute('aria-expanded', 'false')); if (transparent && scrollY < 40) h.classList.remove('is-solid'); };
triggers.forEach((t, i) => {
const m = megas[i]; if (!m) return;
const open = () => { clearTimeout(closeT); megas.forEach(x => x !== m && (x.classList.remove('is-open'), x.hidden = true)); m.hidden = false; requestAnimationFrame(() => m.classList.add('is-open')); t.setAttribute('aria-expanded', 'true'); h.classList.add('is-solid'); };
t.addEventListener('mouseenter', open); t.addEventListener('focus', open);
t.addEventListener('mouseleave', () => closeT = setTimeout(close, 180));
m.addEventListener('mouseenter', () => clearTimeout(closeT));
m.addEventListener('mouseleave', () => closeT = setTimeout(close, 180));
});
document.addEventListener('keydown', e => e.key === 'Escape' && close());
}
/* ---------- Drawers ---------- */
class KamoDrawer extends HTMLElement {
connectedCallback() {
if (this._init) return; this._init = true;
this.addEventListener('click', e => { if (e.target.closest('[data-drawer-close]')) this.close(); });
this.addEventListener('keydown', e => { if (e.key === 'Escape') this.close(); if (e.key === 'Tab') this.trap(e); });
}
open(opener) {
this._opener = opener || document.activeElement; this.hidden = false;
document.body.style.overflow = 'hidden';
requestAnimationFrame(() => requestAnimationFrame(() => this.classList.add('is-open')));
setTimeout(() => { const f = $('[data-predictive-input]', this) || $('button, a, input', $('.drawer__panel', this)); f && f.focus({ preventScroll: true }); }, 80);
}
close() {
this.classList.remove('is-open'); document.body.style.overflow = '';
setTimeout(() => { if (!this.classList.contains('is-open')) this.hidden = true; }, 500);
this._opener && this._opener.focus && this._opener.focus({ preventScroll: true });
}
trap(e) {
const f = $$('a[href], button:not([disabled]), input:not([type=hidden]), select, textarea', $('.drawer__panel', this)).filter(x => x.offsetParent);
if (!f.length) return; const first = f[0], last = f[f.length - 1];
if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
}
}
customElements.define('kamo-drawer', KamoDrawer);
document.addEventListener('click', e => {
const o = e.target.closest('[data-drawer-open]'); if (!o) return;
const d = document.getElementById(o.dataset.drawerOpen);
if (d) { e.preventDefault(); d.open(o); }
});
/* ---------- Predictive search ---------- */
function predictive() {
const input = $('[data-predictive-input]'); if (!input) return;
const box = $('[data-predictive-results]'); const initial = box.innerHTML; let t, ctrl;
input.addEventListener('input', () => {
clearTimeout(t); const q = input.value.trim();
if (q.length < 2) { box.innerHTML = initial; return; }
t = setTimeout(async () => {
ctrl && ctrl.abort(); ctrl = new AbortController();
try {
const r = await fetch(`${K.routes.search}/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product,collection&resources[limit]=8&resources[options][unavailable_products]=last`, { signal: ctrl.signal });
const { resources: { results } } = await r.json();
const prods = results.products || [], cols = results.collections || [];
const esc = s => String(s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
box.innerHTML = (cols.length ? `<div class="predictive__suggest"><p class="predictive__label">Collections</p>${cols.map(c => `<a class="chip" href="${c.url}">${esc(c.title)}</a>`).join('')}</div><br>` : '') +
(prods.length ? `<p class="predictive__label">Products</p><div class="predictive__grid">${prods.map(p => `<a class="predictive__item" href="${p.url}">${p.image ? `<img src="${p.image}${p.image.includes('?') ? '&' : '?'}width=300" alt="" loading="lazy">` : ''}<span>${esc(p.title)}</span><strong>${K.formatMoney(Math.round(parseFloat(p.price) * 100))}</strong></a>`).join('')}</div>` : `<p>No results for “${esc(q)}”.</p>`) +
`<p style="margin-top:20px"><a class="link-arrow" href="${K.routes.search}?q=${encodeURIComponent(q)}&type=product">See all results →</a></p>`;
} catch (e) { if (e.name !== 'AbortError') box.innerHTML = initial; }
}, 220);
});
}
/* ---------- Cart ---------- */
const Cart = {
async refresh() {
const r = await fetch(`${location.pathname}?sections=cart-drawer`); const j = await r.json();
const html = j['cart-drawer'];
if (html) {
const doc = new DOMParser().parseFromString(html, 'text/html');
const drawer = $('#CartDrawer');
if (drawer) { ['.drawer__head', '[data-cart-body]', '.cart-summary'].forEach(sel => {
const cur = $(sel, drawer), nu = $(sel, doc);
if (cur && nu) cur.replaceWith(nu); else if (!cur && nu) $('.drawer__panel', drawer).appendChild(nu); else if (cur && !nu) cur.remove();
}); }
}
const cart = await (await fetch('/cart.js')).json();
$$('[data-cart-count]').forEach(c => { c.textContent = cart.item_count; c.classList.toggle('is-empty', !cart.item_count); c.classList.remove('is-bump'); void c.offsetWidth; c.classList.add('is-bump'); });
if ($('[data-cart-page]')) location.reload();
return cart;
},
async add(formData, btn) {
btn && btn.setAttribute('aria-busy', 'true');
try {
const r = await fetch(K.routes.cart_add + '.js', { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }, body: formData });
const j = await r.json(); if (!r.ok) throw new Error(j.description || j.message || K.strings.error);
await this.refresh();
if (K.cartType === 'drawer' && $('#CartDrawer')) $('#CartDrawer').open(btn);
else K.toast(`${K.strings.added}: ${j.title || ''}`);
if (btn) { btn.classList.add('is-added'); setTimeout(() => btn.classList.remove('is-added'), 1500); }
} catch (e) { K.toast(e.message, true); }
btn && btn.removeAttribute('aria-busy');
},
async change(line, quantity) {
const el = $(`.cart-line[data-line="${line}"]`); el && el.classList.add('is-updating');
try {
const r = await fetch(K.routes.cart_change + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line, quantity }) });
const j = await r.json(); if (!r.ok) throw new Error(j.description || K.strings.error);
await this.refresh();
} catch (e) { K.toast(e.message, true); el && el.classList.remove('is-updating'); }
}
};
K.cart = Cart;
document.addEventListener('submit', e => {
const f = e.target;
if (!(f.matches('[data-ajax-cart]') || f.id === 'ProductForm')) return;
e.preventDefault(); Cart.add(new FormData(f), f.querySelector('[type=submit]'));
});
document.addEventListener('click', e => {
const minus = e.target.closest('[data-qty-minus]'), plus = e.target.closest('[data-qty-plus]'), rm = e.target.closest('[data-line-remove]');
if (minus || plus) {
const input = $('input', (minus || plus).closest('[data-qty]'));
const min = parseInt(input.min || 0, 10); input.value = Math.max(min, (parseInt(input.value, 10) || 0) + (plus ? 1 : -1));
input.dispatchEvent(new Event('change', { bubbles: true }));
}
if (rm) Cart.change(parseInt(rm.dataset.lineRemove, 10), 0);
});
let qtyT;
document.addEventListener('change', e => {
const q = e.target.closest('[data-line-qty]');
if (q) { clearTimeout(qtyT); qtyT = setTimeout(() => Cart.change(parseInt(q.dataset.lineQty, 10), Math.max(0, parseInt(q.value, 10) || 0)), 350); }
const note = e.target.closest('[data-cart-note]');
if (note) fetch(K.routes.cart_update + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: note.value }) });
});
/* ---------- Hero (video 1) ---------- */
class KamoHero extends HTMLElement {
connectedCallback() {
if (this._init) return; this._init = true;
this.bgs = $$('.hero__bg', this); this.count = this.bgs.length; this.i = 0;
this.fgs = $$('.hero__fg', this); this.pins = $$('.hero__pin', this); this.ctas = $$('.hero__cta', this);
this.segs = $$('.hero__progress-seg', this); this.cards = $$('.terrain-card', this);
this.nameEl = $('[data-name]', this); this.indexEl = $('[data-index]', this);
this.panel = $('.hero__panel', this); this.fx = this.dataset.textFx;
this.interval = parseInt(this.dataset.interval, 10) || 7000;
this.autoplay = this.dataset.autoplay === 'true' && this.count > 1 && !reduced;
this.labels = this.bgs.map(b => b.dataset.label || '');
this.setCamo(0);
this.introTitle();
$('[data-prev]', this)?.addEventListener('click', () => this.go(this.i - 1, true));
$('[data-next]', this)?.addEventListener('click', () => this.go(this.i + 1, true));
this.cards.forEach(c => c.addEventListener('click', () => { this.go(+c.dataset.goto, true); this.togglePanel(false); }));
$('[data-panel-open]', this)?.addEventListener('click', () => this.togglePanel(true));
$('[data-panel-close]', this)?.addEventListener('click', () => this.togglePanel(false));
this.addEventListener('keydown', e => { if (e.key === 'ArrowRight') this.go(this.i + 1, true); if (e.key === 'ArrowLeft') this.go(this.i - 1, true); if (e.key === 'Escape') this.togglePanel(false); });
this.addEventListener('mouseenter', () => this.pause('hover')); this.addEventListener('mouseleave', () => this.resume('hover'));
this.addEventListener('focusin', () => this.pause('focus')); this.addEventListener('focusout', () => this.resume('focus'));
this.swipe();
if (this.dataset.pointer === 'true' && fine && !animOff()) this.parallax();
this.paused = new Set();
new IntersectionObserver(([en]) => en.isIntersecting ? this.resume('view') : this.pause('view'), { threshold: 0.2 }).observe(this);
document.addEventListener('visibilitychange', () => document.hidden ? this.pause('tab') : this.resume('tab'));
this.playVideo(0); this.updateUI(0, false);
this.pins[0] && setTimeout(() => { this.pins[0].classList.add('is-peek'); setTimeout(() => this.pins[0].classList.remove('is-peek'), 2600); }, 1800);
this.startTimer();
document.addEventListener('shopify:block:select', e => { const idx = this.bgs.findIndex(b => b.contains(e.target) || b === e.target); if (idx > -1) { this.go(idx); this.pause('editor'); } });
document.addEventListener('shopify:block:deselect', () => this.resume('editor'));
}
introTitle() {
const parts = $$('[data-split="chars"]', this);
if (animOff() || this.fx === 'none') return;
parts.forEach((p, k) => { splitChars(p); p.style.setProperty('--d', `${300 + k * 220}ms`); });
const go = () => requestAnimationFrame(() => this.classList.add('is-in'));
const pl = $('#Preloader'); if (pl && !pl.classList.contains('is-skip')) { const mo = new MutationObserver(() => { if (pl.classList.contains('is-done')) { mo.disconnect(); setTimeout(go, 250); } }); mo.observe(pl, { attributes: true }); } else setTimeout(go, 100);
}
setCamo(i) { const camo = getComputedStyle(this.bgs[i]).getPropertyValue('--slide-camo'); if (camo) this.style.setProperty('--title-camo', camo); }
go(n, user = false) {
if (this.count < 2) return;
n = (n + this.count) % this.count; if (n === this.i) return;
const prev = this.i; this.i = n;
this.bgs.forEach((b, k) => { b.classList.toggle('is-active', k === n); b.classList.toggle('was-active', k === prev); });
setTimeout(() => this.bgs[prev] && this.bgs[prev].classList.remove('was-active'), 1600);
[this.fgs, this.pins, this.ctas].forEach(list => list.forEach(el => el.classList.toggle('is-active', +el.dataset.slide === n)));
this.ctas.forEach(c => c.tabIndex = +c.dataset.slide === n ? 0 : -1);
this.playVideo(n); this.setCamo(n); this.updateUI(n, true);
this.startTimer();
}
updateUI(n, animate) {
if (this.indexEl) this.indexEl.textContent = `(${String(n + 1).padStart(2, '0')})`;
this.cards.forEach((c, k) => c.classList.toggle('is-current', k === n));
this.segs.forEach((s, k) => { s.classList.toggle('is-done', k < n); s.classList.remove('is-active'); if (k === n) { void s.offsetWidth; if (this.autoplay) s.classList.add('is-active'); else s.classList.add('is-done'); } });
const label = this.labels[n] || '';
if (!this.nameEl) return;
if (!animate || animOff() || this.fx === 'none') { this.nameEl.textContent = label; return; }
if (this.fx === 'scramble') return this.scramble(this.nameEl, label);
if (this.fx === 'fade') { this.nameEl.style.opacity = 0; setTimeout(() => { this.nameEl.textContent = label; this.nameEl.style.transition = 'opacity .5s'; this.nameEl.style.opacity = 1; }, 200); return; }
this.nameEl.textContent = label; delete this.nameEl.dataset.splitDone; splitChars(this.nameEl);
this.nameEl.classList.remove('is-in'); void this.nameEl.offsetWidth; requestAnimationFrame(() => this.nameEl.classList.add('is-in'));
}
scramble(el, to) {
const glyphs = 'ABCDEFGHJKLMNPQRSTUVWXYZ0123456789#/+';
let frame = 0; const len = to.length; cancelAnimationFrame(this._sc);
const step = () => { frame++; el.textContent = [...to].map((ch, k) => (k < frame / 2 || ch === ' ') ? ch : glyphs[Math.floor(Math.random() * glyphs.length)]).join(''); if (frame / 2 < len) this._sc = requestAnimationFrame(step); else el.textContent = to; };
step();
}
playVideo(n) { this.bgs.forEach((b, k) => { const v = $('video', b); if (!v) return; if (k === n) { v.muted = true; const p = v.play(); p && p.catch(() => {}); } else v.pause(); }); }
startTimer() { clearTimeout(this.t); if (!this.autoplay || (this.paused && this.paused.size)) return; this.t = setTimeout(() => this.go(this.i + 1), this.interval); this._started = performance.now(); this._remaining = this.interval; }
pause(reason) { if (!this.paused) return; this.paused.add(reason); clearTimeout(this.t); this.classList.add('is-paused'); if (this._started) this._remaining = Math.max(400, this._remaining - (performance.now() - this._started)); }
resume(reason) { if (!this.paused) return; this.paused.delete(reason); if (this.paused.size || !this.autoplay) return; this.classList.remove('is-paused'); clearTimeout(this.t); this._started = performance.now(); this.t = setTimeout(() => this.go(this.i + 1), this._remaining || this.interval); }
togglePanel(open) {
if (!this.panel) return; const btn = $('[data-panel-open]', this);
if (open) {
this.panel.hidden = false; this.pause('panel'); btn && btn.setAttribute('aria-expanded', 'true');
requestAnimationFrame(() => requestAnimationFrame(() => this.panel.classList.add('is-open')));
this.type($('.hero__panel-title', this.panel));
setTimeout(() => $('.terrain-card', this.panel)?.focus({ preventScroll: true }), 500);
} else {
if (!this.panel.classList.contains('is-open')) return;
this.panel.classList.remove('is-open'); btn && btn.setAttribute('aria-expanded', 'false'); this.resume('panel');
setTimeout(() => { if (!this.panel.classList.contains('is-open')) this.panel.hidden = true; }, 900);
}
}
type(el) {
if (!el) return; const full = el.dataset.type || el.textContent;
if (animOff()) { el.textContent = full; return; }
clearInterval(this._ty); let k = 0; el.innerHTML = '<span></span><i class="caret"></i>'; const s = el.firstChild;
setTimeout(() => { this._ty = setInterval(() => { s.textContent = full.slice(0, ++k); if (k >= full.length) { clearInterval(this._ty); setTimeout(() => el.querySelector('.caret')?.remove(), 1400); } }, 55); }, 350);
}
swipe() {
let x0 = null, y0 = null;
this.addEventListener('touchstart', e => { if (e.target.closest('.hero__panel')) return; x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
this.addEventListener('touchend', e => { if (x0 === null) return; const dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0; if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) this.go(this.i + (dx < 0 ? 1 : -1), true); x0 = null; }, { passive: true });
}
parallax() {
let raf;
this.addEventListener('pointermove', e => {
const r = this.getBoundingClientRect(); const nx = (e.clientX - r.left) / r.width - .5, ny = (e.clientY - r.top) / r.height - .5;
cancelAnimationFrame(raf); raf = requestAnimationFrame(() => {
$$('[data-depth]', this).forEach(el => { const d = +el.dataset.depth; el.style.transform = `translate3d(${-nx * d}px, ${-ny * d}px, 0)`; });
const head = $('.hero__head', this); head && (head.style.transform = `translate3d(${nx * 6}px, ${ny * 4}px, 0)`);
});
});
this.addEventListener('pointerleave', () => { $$('[data-depth]', this).forEach(el => el.style.transform = ''); const head = $('.hero__head', this); head && (head.style.transform = ''); });
}
}
customElements.define('kamo-hero', KamoHero);
/* ---------- Tabs + slider ---------- */
function slider(track, bar) {
if (!track || track._s) return; track._s = true;
const upd = () => { if (!bar) return; const max = track.scrollWidth - track.clientWidth; const w = track.clientWidth / track.scrollWidth; bar.style.setProperty('--w', `${w * 100}%`); bar.style.setProperty('--x', `${max > 0 ? (track.scrollLeft / max) * ((1 - w) / w) * 100 : 0}%`); };
track.addEventListener('scroll', upd, { passive: true }); addEventListener('resize', upd); upd();
if (fine) {
let down = false, sx = 0, sl = 0, moved = false;
track.addEventListener('pointerdown', e => { if (e.pointerType !== 'mouse') return; down = true; moved = false; sx = e.clientX; sl = track.scrollLeft; });
addEventListener('pointermove', e => { if (!down) return; const dx = e.clientX - sx; if (Math.abs(dx) > 5) { moved = true; track.classList.add('is-dragging'); } track.scrollLeft = sl - dx; });
addEventListener('pointerup', () => { if (!down) return; down = false; setTimeout(() => track.classList.remove('is-dragging'), 0); });
track.addEventListener('click', e => { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
}
return upd;
}
class KamoTabs extends HTMLElement {
connectedCallback() {
if (this._init) return; this._init = true;
this.tabs = $$('[data-tab]', this); this.panels = $$('.ptabs__panel', this); this.bar = $('[data-slider-bar]', this);
this.tabs.forEach(t => t.addEventListener('click', () => this.show(+t.dataset.tab)));
this.panels.forEach(p => slider($('[data-slider]', p), this.bar));
const step = dir => { const tr = this.track(); if (!tr) return; const item = $('.slider__item', tr); tr.scrollBy({ left: dir * (item ? item.getBoundingClientRect().width + 20 : 300) * (isMobile() ? 1 : 2), behavior: 'smooth' }); };
$('[data-slide-prev]', this)?.addEventListener('click', () => step(-1));
$('[data-slide-next]', this)?.addEventListener('click', () => step(1));
if (this.dataset.autoplay === 'true' && !reduced) {
const iv = +this.dataset.interval || 5000; let hover = false;
this.addEventListener('mouseenter', () => hover = true); this.addEventListener('mouseleave', () => hover = false);
setInterval(() => { if (hover || document.hidden) return; const tr = this.track(); if (!tr) return; if (tr.scrollLeft + tr.clientWidth >= tr.scrollWidth - 4) tr.scrollTo({ left: 0, behavior: 'smooth' }); else step(1); }, iv);
}
document.addEventListener('shopify:block:select', e => { const i = this.tabs.indexOf(e.target); if (i > -1) this.show(i); });
}
track() { return $('.ptabs__panel.is-active [data-slider]', this) || $('[data-slider]', this); }
show(i) {
this.tabs.forEach((t, k) => { t.classList.toggle('is-active', k === i); t.setAttribute('aria-selected', k === i); });
this.panels.forEach((p, k) => { p.classList.toggle('is-active', k === i); p.hidden = k !== i; });
const tr = this.track(); tr && tr.dispatchEvent(new Event('scroll'));
reveals(this.panels[i]);
}
}
customElements.define('kamo-tabs', KamoTabs);
/* ---------- Scroll-driven effects (one rAF loop) ---------- */
const scrollers = new Set();
let ticking = false;
const runScroll = () => { ticking = false; scrollers.forEach(fn => fn()); };
const onScroll = () => { if (!ticking) { ticking = true; requestAnimationFrame(runScroll); } };
addEventListener('scroll', onScroll, { passive: true }); addEventListener('resize', onScroll);
function watch(el, fn) { const ob = new IntersectionObserver(([en]) => { if (en.isIntersecting) scrollers.add(fn); else scrollers.delete(fn); }, { rootMargin: '20% 0px' }); ob.observe(el); fn(); }
class KamoBlueprint extends HTMLElement {
connectedCallback() {
if (this._init) return; this._init = true;
const mode = this.dataset.mode;
if (animOff()) { this.style.setProperty('--p', 1); return; }
if (mode === 'hover' && fine) {
this.style.setProperty('--p', 1);
this.addEventListener('pointermove', e => { const r = this.getBoundingClientRect(); this.style.setProperty('--hx', clamp((e.clientX - r.left) / r.width, 0, 1) * 100); });
return;
}
if (mode === 'auto') { new IntersectionObserver(([en], ob) => { if (en.isIntersecting) { ob.disconnect(); const t0 = performance.now(); const a = now => { const p = clamp((now - t0) / 2200); this.style.setProperty('--p', 1 - Math.pow(1 - p, 3)); if (p < 1) requestAnimationFrame(a); }; setTimeout(() => requestAnimationFrame(a), 400); } }, { threshold: .4 }).observe(this); return; }
watch(this, () => { const r = this.getBoundingClientRect(), vh = innerHeight; const p = clamp((vh * 0.85 - r.top) / (r.height * 0.9)); this.style.setProperty('--p', p.toFixed(3)); });
}
}
customElements.define('kamo-blueprint', KamoBlueprint);
class KamoIndex extends HTMLElement {
connectedCallback() {
if (this._init) return; this._init = true;
const items = $$('.cidx__item', this), imgs = $$('.cidx__img', this);
const set = i => { items.forEach((it, k) => { it.classList.toggle('is-active', k === i); $('.cidx__btn', it).setAttribute('aria-expanded', k === i); }); imgs.forEach((im, k) => im.classList.toggle('is-active', k === i)); };
items.forEach((it, i) => {
$('.cidx__btn', it).addEventListener('click', () => set(i));
if (this.dataset.trigger === 'hover' && fine) it.addEventListener('mouseenter', () => set(i));
});
document.addEventListener('shopify:block:select', e => { const i = items.indexOf(e.target); if (i > -1) set(i); });
}
}
customElements.define('kamo-index', KamoIndex);
class KamoHscroll extends HTMLElement {
connectedCallback() {
if (this._init) return; this._init = true;
const track = $('[data-track]', this), bar = $('[data-hbar]', this);
const desktop = matchMedia('(min-width: 990px)');
const fn = () => {
if (!desktop.matches || this.dataset.pin !== 'true') { track.style.transform = ''; if (bar) { const max = track.scrollWidth - track.clientWidth; bar.style.setProperty('--hp', max > 0 ? track.scrollLeft / max : 0); } return; }
const r = this.getBoundingClientRect(); const total = r.height - innerHeight; const p = clamp(-r.top / (total || 1));
const dist = track.scrollWidth - innerWidth; track.style.transform = `translate3d(${-p * Math.max(0, dist)}px,0,0)`;
bar && bar.style.setProperty('--hp', p.toFixed(3));
};
track.addEventListener('scroll', fn, { passive: true });
watch(this, fn);
}
}
customElements.define('kamo-hscroll', KamoHscroll);
class KamoDossier extends HTMLElement {
connectedCallback() {
if (this._init) return; this._init = true;
const dev = $('[data-device]', this), scr = $('[data-screen]', this);
if (!dev || animOff()) return;
watch(this, () => {
const r = this.getBoundingClientRect(), vh = innerHeight; const p = clamp((vh - r.top) / (r.height + vh));
const off = -Math.max(0, (scr.firstElementChild ? Array.from(scr.children).reduce((a, c) => a + c.offsetHeight, 0) : 0) - scr.clientHeight) * clamp((p - .2) / .6);
scr.style.setProperty('--scroll', `${off}px`);
dev.style.setProperty('--rot', `${(-6 + p * 10).toFixed(2)}deg`); dev.style.setProperty('--ty', `${((.5 - p) * 60).toFixed(1)}px`);
});
}
}
customElements.define('kamo-dossier', KamoDossier);
class KamoSlides extends HTMLElement {
connectedCallback() {
if (this._init) return; this._init = true;
this.s = $$('[data-slide]', this); this.i = 0; this.c = $('[data-count]', this);
$('[data-prev]', this)?.addEventListener('click', () => { this.go(this.i - 1); this.restart(); });
$('[data-next]', this)?.addEventListener('click', () => { this.go(this.i + 1); this.restart(); });
this.auto = this.dataset.autoplay === 'true' && this.s.length > 1 && !reduced; this.iv = +this.dataset.interval || 7000;
this.addEventListener('mouseenter', () => this.hover = true); this.addEventListener('mouseleave', () => this.hover = false);
this.restart(); this.go(0);
document.addEventListener('shopify:block:select', e => { const i = this.s.indexOf(e.target); if (i > -1) this.go(i); });
}
restart() { clearInterval(this.t); if (this.auto) this.t = setInterval(() => { if (!this.hover && !document.hidden) this.go(this.i + 1); }, this.iv); }
go(n) {
n = (n + this.s.length) % this.s.length; this.i = n;
this.s.forEach((s, k) => { s.classList.toggle('is-active', k === n); const v = $('video', s); if (v) k === n ? v.play().catch(() => {}) : v.pause(); });
if (this.c) this.c.textContent = `${n + 1} / ${this.s.length}`;
}
}
customElements.define('kamo-slides', KamoSlides);
/* ---------- Collection facets ---------- */
class KamoFacets extends HTMLElement {
connectedCallback() {
if (this._init) return; this._init = true;
this.sid = this.dataset.section;
this.addEventListener('change', e => {
if (e.target.closest('[data-facet-form]')) { clearTimeout(this._t); this._t = setTimeout(() => this.apply(), 400); }
if (e.target.matches('[data-sort]')) { const u = new URL(location.href); u.searchParams.set('sort_by', e.target.value); u.searchParams.delete('page'); this.load(u.search); }
});
this.addEventListener('click', e => {
const l = e.target.closest('[data-facet-link]'); if (l) { e.preventDefault(); this.load(new URL(l.href, location.origin).search); return; }
const d = e.target.closest('[data-density]'); if (d) { $$('[data-density]', this).forEach(b => b.classList.toggle('is-active', b === d)); $('[data-grid]', this).style.setProperty('--cols', d.dataset.density); }
const m = e.target.closest('[data-load-more]'); if (m) this.more(m);
});
addEventListener('popstate', () => this.load(location.search, false));
}
apply() {
const form = $('[data-facet-form]', this); const p = new URLSearchParams(new FormData(form));
[...p.entries()].forEach(([k, v]) => { if (v === '') p.delete(k); });
this.load('?' + p.toString());
}
async load(search, push = true) {
const grid = $('[data-grid]', this); grid && grid.classList.add('is-loading');
try {
const r = await fetch(`${location.pathname}${search}${search.includes('?') ? '&' : '?'}section_id=${this.sid}`);
const doc = new DOMParser().parseFromString(await r.text(), 'text/html');
const fresh = $('kamo-facets', doc); if (!fresh) throw 0;
const drawerOpen = $('#FacetDrawer', this)?.classList.contains('is-open');
const openDetails = $$('#FacetDrawer details', this).map(d => d.open);
const keep = $('#FacetDrawer', this);
[...this.children].forEach(c => { if (c.id !== 'FacetDrawer') c.remove(); });
[...fresh.children].reverse().forEach(c => { if (c.id === 'FacetDrawer') { const nb = $('.facets', c), ob = $('.facets', keep); if (nb && ob) ob.replaceWith(nb); const nf = $('.drawer__foot', c), of = $('.drawer__foot', keep); nf && of && of.replaceWith(nf); } else this.prepend(c); });
if (keep && !keep.isConnected) this.appendChild(keep);
$$('#FacetDrawer details', this).forEach((d, k) => { if (openDetails[k] !== undefined) d.open = openDetails[k]; });
if (drawerOpen) keep.classList.add('is-open');
if (push) history.pushState({}, '', `${location.pathname}${search}`);
reveals(this); $$('[data-reveal]', this).forEach(e => e.classList.add('is-in'));
} catch (e) { location.search = search; }
}
async more(btn) {
btn.textContent = 'Loading…'; btn.disabled = true;
const u = new URL(btn.dataset.loadMore, location.origin); u.searchParams.set('section_id', this.sid);
const doc = new DOMParser().parseFromString(await (await fetch(u)).text(), 'text/html');
const grid = $('[data-grid]', this);
$$('[data-grid] > .card', doc).forEach(c => { grid.appendChild(c); });
reveals(grid);
const nm = $('.mcol__more', doc), om = $('.mcol__more', this);
if (nm) om.replaceWith(nm); else om.remove();
}
}
customElements.define('kamo-facets', KamoFacets);
/* ---------- Product ---------- */
class KamoProduct extends HTMLElement {
connectedCallback() {
if (this._init) return; this._init = true;
const j = $('[data-product-json]', this); this.data = j ? JSON.parse(j.textContent) : { variants: [] };
this.form = $('#ProductForm', this) || $('form[action*="/cart/add"]', this);
this.addEventListener('change', e => { if (e.target.matches('[data-option]')) this.onOption(); });
$$('[data-thumb]', this).forEach(t => t.addEventListener('click', () => this.showMedia(t.dataset.thumb)));
this.zoom(); this.sticky(); this.dots(); this.share();
}
onOption() {
const opts = $$('fieldset[data-option-index]', this).map(f => { const c = $('input:checked', f); $('[data-option-value]', f).textContent = c ? c.value : ''; return c ? c.value : null; });
let v = this.data.variants.find(v => v.options.every((o, i) => o === opts[i]));
this.markAvailability(opts);
const btn = $('[data-atc]', this), txt = $('[data-atc-text]', this), idIn = $('[data-variant-id]', this), stock = $('[data-stock]', this);
if (!v) { btn && (btn.disabled = true); txt && (txt.textContent = K.strings.unavailable); return; }
idIn && (idIn.value = v.id);
btn && (btn.disabled = !v.available); txt && (txt.textContent = v.available ? K.strings.addToCart : K.strings.soldOut);
if (stock) stock.innerHTML = v.available ? '<i class="dot dot--ok"></i> In stock, ready to ship' : '<i class="dot"></i> Currently unavailable';
const pw = $('[data-price-wrap]', this);
if (pw) { const sale = v.compare_at_price > v.price; pw.innerHTML = `<div class="price${sale ? ' price--sale' : ''}"><span class="price__now">${K.formatMoney(v.price)}</span>${sale ? `<s class="price__was">${K.formatMoney(v.compare_at_price)}</s>` : ''}</div>`; }
const sv = $('[data-sticky-variant]', this); sv && (sv.textContent = v.title);
if (v.featured_media) this.showMedia(v.featured_media);
const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u);
}
markAvailability(selected) {
$$('fieldset[data-option-index]', this).forEach(f => {
const idx = +f.dataset.optionIndex;
$$('input[data-option]', f).forEach(inp => {
const test = selected.slice(); test[idx] = inp.value;
const ok = this.data.variants.some(v => v.available && v.options.every((o, i) => o === test[i]));
inp.closest('.opt__pill').classList.toggle('is-unavailable', !ok);
});
});
}
showMedia(id) {
const m = $(`[data-media-id="${id}"]`, this); if (!m) return;
$$('[data-media-id]', this).forEach(x => x.classList.toggle('is-active', x === m));
$$('[data-thumb]', this).forEach(t => t.classList.toggle('is-active', t.dataset.thumb == id));
const list = $('[data-media-list]', this);
if (getComputedStyle(list).display === 'flex') list.scrollTo({ left: m.offsetLeft - list.offsetLeft - parseInt(getComputedStyle(list).paddingLeft), behavior: 'smooth' });
else if (!this.classList.contains('pdp--slider')) { const r = m.getBoundingClientRect(); if (r.top < 0 || r.bottom > innerHeight) scrollTo({ top: scrollY + r.top - 100, behavior: 'smooth' }); }
}
dots() {
const list = $('[data-media-list]', this), dots = $$('.pdp__dots i', this); if (!dots.length) return;
list.addEventListener('scroll', () => { const i = Math.round(list.scrollLeft / (list.firstElementChild.offsetWidth + 8)); dots.forEach((d, k) => d.classList.toggle('is-active', k === i)); }, { passive: true });
}
zoom() {
const lb = $('[data-lightbox]', this.parentElement), img = lb && $('[data-lightbox-img]', lb); if (!lb) return;
this.addEventListener('click', e => { const z = e.target.closest('[data-zoom]'); if (!z) return; const im = $('img', z); img.src = (im.currentSrc || im.src).replace(/width=\d+/, 'width=2400'); img.alt = im.alt; lb.hidden = false; document.body.style.overflow = 'hidden'; $('[data-lightbox-close]', lb).focus(); });
const close = () => { lb.hidden = true; document.body.style.overflow = ''; };
lb.addEventListener('click', close); document.addEventListener('keydown', e => e.key === 'Escape' && !lb.hidden && close());
}
sticky() {
const bar = $('[data-sticky-atc]', this), atc = $('[data-atc]', this); if (!bar || !atc) return;
new IntersectionObserver(([en]) => { const show = !en.isIntersecting && en.boundingClientRect.top < 0; bar.classList.toggle('is-visible', show); bar.setAttribute('aria-hidden', !show); $('[data-sticky-buy]', bar).tabIndex = show ? 0 : -1; }).observe(atc);
$('[data-sticky-buy]', bar).addEventListener('click', () => { if (atc.disabled) { atc.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; } this.form.requestSubmit ? this.form.requestSubmit(atc) : atc.click(); });
}
share() {
const b = $('[data-share]', this); if (!b) return;
b.addEventListener('click', async () => { const url = b.dataset.url, title = b.dataset.title; if (navigator.share) { try { await navigator.share({ url, title }); } catch (e) {} } else { await navigator.clipboard.writeText(url); K.toast('Link copied'); } });
}
}
customElements.define('kamo-product', KamoProduct);
class KamoRecs extends HTMLElement {
connectedCallback() {
if (this._init || this.children.length) return; this._init = true;
new IntersectionObserver(async ([en], ob) => {
if (!en.isIntersecting) return; ob.disconnect();
try { const doc = new DOMParser().parseFromString(await (await fetch(this.dataset.url)).text(), 'text/html'); const fresh = $('kamo-recs', doc); if (fresh && fresh.innerHTML.trim()) { this.innerHTML = fresh.innerHTML; reveals(this); } else this.closest('.sec').hidden = true; } catch (e) {}
}, { rootMargin: '400px' }).observe(this);
}
}
customElements.define('kamo-recs', KamoRecs);
/* ---------- Parallax, wordmark, magnetic, tilt ---------- */
function fitWordmark(root = document) {
$$('[data-wordmark]', root).forEach(el => {
const t = el.firstElementChild; if (!t) return;
const fit = () => { t.style.fontSize = ''; const base = parseFloat(getComputedStyle(t).fontSize); const avail = el.clientWidth - 8; if (t.scrollWidth > avail) t.style.fontSize = `${Math.floor(base * avail / t.scrollWidth)}px`; };
fit(); addEventListener('resize', fit);
});
}
function parallax(root = document) {
if (animOff()) return;
$$('[data-parallax="true"]', root).forEach(el => watch(el, () => { const r = el.parentElement.getBoundingClientRect(); const p = (r.top + r.height / 2 - innerHeight / 2) / innerHeight; el.style.transform = `translate3d(0, ${(p * -8).toFixed(2)}%, 0)`; }));
$$('[data-wordmark]', root).forEach(el => { const t = el.firstElementChild; watch(el, () => { const r = el.getBoundingClientRect(); const p = clamp((innerHeight - r.top) / (r.height + 120)); t.style.setProperty('--wm', `${((1 - p) * 60).toFixed(1)}%`); }); });
}
function magnetic(root = document) {
if (!K.magnetic || !fine || animOff()) return;
$$('[data-magnetic]', root).forEach(el => {
if (el._mag) return; el._mag = true;
el.addEventListener('pointermove', e => { const r = el.getBoundingClientRect(); el.style.transform = `translate(${(e.clientX - r.left - r.width / 2) * .22}px, ${(e.clientY - r.top - r.height / 2) * .3}px)`; });
el.addEventListener('pointerleave', () => el.style.transform = '');
});
}
function tilt(root = document) {
if (!fine || animOff()) return;
$$('.card--tilt', root).forEach(c => { if (c._t) return; c._t = true; const m = $('.card__media', c);
c.addEventListener('pointermove', e => { const r = m.getBoundingClientRect(); m.style.setProperty('--ry', `${((e.clientX - r.left) / r.width - .5) * 8}deg`); m.style.setProperty('--rx', `${-((e.clientY - r.top) / r.height - .5) * 8}deg`); });
c.addEventListener('pointerleave', () => { m.style.setProperty('--rx', 0); m.style.setProperty('--ry', 0); });
});
}
/* ---------- Init ---------- */
function initScope(root = document) { fitWordmark(root); reveals(root); parallax(root); magnetic(root); tilt(root); }
document.addEventListener('DOMContentLoaded', async () => {
header(); predictive();
const fonts = document.fonts ? Promise.race([document.fonts.ready, new Promise(r => setTimeout(r, 1500))]) : Promise.resolve();
if (!K.designMode && K.preloader && K.preloader.enabled) await Promise.all([preloader(), fonts]); else { $('#Preloader')?.remove(); await fonts; }
initScope();
});
document.addEventListener('shopify:section:load', e => initScope(e.target));
})();
